import CTNField from '@ctn/ui/components/ctn-field';
import { type CTNInputGroupIconButtonProps } from '@ctn/ui/types/ctn-input-group';
import { type Control, Controller, type FieldValues, type Path } from 'react-hook-form';

import TextIcon from '@/components/TextIcon';

import type { CTNFieldProps } from '@ctn/ui/types/ctn-field';

type FieldDisplayProps<T extends FieldValues> = Omit<CTNFieldProps, 'children'> & {
	readonly control?: Control<T>;
	readonly name: Path<T>;
	readonly iconLeft?: CTNInputGroupIconButtonProps;
	readonly iconRight?: CTNInputGroupIconButtonProps;
};

const FieldDisplay = <T extends Record<string, unknown>>({
	control,
	name,
	iconLeft,
	iconRight,
	...propsField
}: FieldDisplayProps<T>) => (
	<Controller
		control={control}
		name={name}
		render={({ field }) => (
			<CTNField {...propsField}>
				<TextIcon isFit iconLeft={iconLeft} iconRight={iconRight} description={field.value as string} />
			</CTNField>
		)}
	/>
);

export default FieldDisplay;
